import React from "react";
import { FaTimes } from "react-icons/fa";
import ActionDropdown from "./ActionDropdown";

const DocumentTable = ({
  paginatedDocuments,
  searchText,
  tags,
  expandedRows,
  toggleExpand,
  removeKeyword,
  handleOpenDocumentModal,
  handleOpenModal,
  handleOpenSummaryModal,
  handleOpenFormOffcanvas,
  handleOpenDetailsOffcanvas,
}) => {
  const highlightText = (text, searchTerms) => {
    if (text === null || text === undefined) return "N/A";
    const textStr = String(text);

    const allSearchTerms = [
      ...(searchText ? [searchText.trim()] : []),
      ...tags,
    ].filter((term) => term.trim());

    if (!allSearchTerms || allSearchTerms.length === 0) return textStr;

    const escapedTerms = allSearchTerms.map((term) =>
      term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");
    const parts = textStr.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#FFD700",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const searchTerms = searchText
    ? searchText.split(" ").filter((term) => term.trim())
    : [];

  return (
    <div className="modern-table-container" style={{ minHeight: "300px" }}>
      <div className="table-wrapper">
        <table className="modern-table">
          <thead>
            <tr>
              <th className="sortable-header">
                <div className="th-content">
                  <span>Contract Name</span>
                </div>
              </th>

              <th className="sortable-header">
                <div className="th-content">
                  <span>File Name</span>
                </div>
              </th>

              <th className="sortable-header">
                <div className="th-content">
                  <span>Size (MB)</span>
                </div>
              </th>

              <th className="sortable-header">
                <div className="th-content">
                  <span>Keywords</span>
                  <i
                    className="bi bi-question-circle-fill ms-2 text-dark"
                    title="These keywords are AI generated from document content."
                  />
                </div>
              </th>

              <th className="action-column">
                <div className="th-content">
                  <span>Actions</span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {paginatedDocuments.length === 0 ? (
              <tr>
                <td colSpan={5}>
                  <div className="empty-state-content">
                    <div className="empty-state-icon">
                      <i className="bi bi-inbox"></i>
                    </div>
                    <h5 className="empty-state-text">
                      No Contracts Complate
                    </h5>
                  </div>
                </td>
              </tr>
            ) : (
              paginatedDocuments.map((doc, index) => (
                <tr key={index} className="table-row">
                  {/* SLEEVE NAME */}
                  <td className="table-cell">
                    <span className="cell-content">
                      {highlightText(doc.sleeve_name, searchTerms)}
                    </span>
                  </td>

                  {/* FILE NAME */}
                  <td className="table-cell clickable-cell">
                    <span
                      className="cell-content primary-text"
                      onClick={() => handleOpenDocumentModal(doc)}
                    >
                      {doc.file_name}
                    </span>
                  </td>

                  {/* SIZE */}
                  <td className="table-cell">
                    {(doc.sign_file_size / 1024).toFixed(2)}
                  </td>

                  {/* KEYWORDS */}
                  <td className="table-cell">
                    <div className="collaborators-list">
                      {doc.keywords.length === 0 && (
                        <span className="text-muted">No keywords</span>
                      )}

                      {doc.keywords.slice(0, 2).map((keyword, idx) => (
                        <span key={idx} className="collaborator-badge">
                          {highlightText(keyword, searchTerms)}
                          <FaTimes
                            className="ms-2 text-dark cur-pointer"
                            onClick={() => removeKeyword(doc, keyword)}
                          />
                        </span>
                      ))}

                      {doc.keywords.length > 2 && (
                        <>
                          {expandedRows[index] &&
                            doc.keywords.slice(2).map((keyword, idx) => (
                              <span key={idx + 2} className="collaborator-badge">
                                {highlightText(keyword, searchTerms)}
                                <FaTimes
                                  className="ms-2 text-dark cur-pointer"
                                  onClick={() => removeKeyword(doc, keyword)}
                                />
                              </span>
                            ))}

                          <span
                            className="show-more ms-2 cur-pointer text-primary"
                            onClick={() => toggleExpand(index)}
                          >
                            {expandedRows[index]
                              ? "Show Less"
                              : `Show More (${doc.keywords.length - 2})`}
                          </span>
                        </>
                      )}
                    </div>
                  </td>

                  {/* ACTIONS */}
                  <td className="table-cell action-cell">
                    <ActionDropdown
                      doc={doc}
                      handleOpenModal={handleOpenModal}
                      handleOpenSummaryModal={handleOpenSummaryModal}
                      handleOpenFormOffcanvas={handleOpenFormOffcanvas}
                      handleOpenDetailsOffcanvas={handleOpenDetailsOffcanvas}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocumentTable;
